module.exports = __webpack_public_path__ + "static/media/buy_request_details_help_5-3.121a41e9.png";